import axios from "axios";
import {WORKFLOW_API_HOST} from "@/core/variables";
import {WorkflowLogStatus} from "@/model/Log";

class WorkflowResultRepository {
    async read(resultId: string) {
        return axios.get(`${WORKFLOW_API_HOST}/v2/workflow-results/${resultId}`);
    };

    async paginate(page: number, size: number, groupId?: string, status?: WorkflowLogStatus, workflowIds?: string) {
        return axios.get(`${WORKFLOW_API_HOST}/v2/workflow-results`, {
            params: {
                page: page,
                size: size,
                groupId: groupId,
                status: status,
                workflowIds: workflowIds
            }
        });
    };
}

const workflowResultRepository = new WorkflowResultRepository();
export default workflowResultRepository;
